import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";

/**
 * This react component is a custom version of the DashboardsColorIcon svg, with color overrides.
 * TODO - remove this once V5 introduces the DashboardsIcon, which can be used in the HeroAssetsIcon instead.
 */
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M15.397 12.625A6 6 0 1 1 10 4v6s2.25 1.125 5.397 2.625"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.3 4.443a5.601 5.601 0 1 0 5.517 8.415l-5.052-1.805a.7.7 0 0 1-.465-.66zm1.4 0V8.9l3.337-2.78A5.6 5.6 0 0 0 10.7 4.443m4.175 2.8-3.485 2.904 3.987 1.424A5.6 5.6 0 0 0 15.6 10a5.6 5.6 0 0 0-.725-2.758M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=DashboardsIcon20.js.map